/**
 * Created by vsuthar on 9/15/21
 * File: TsgFlattenTree
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */
import _ from 'lodash'
import { ROOT_NODE_ID } from '../../tenancy/constants/TenancyConstants'

const FlattenTree = (treeData, collection, parent) => {
  if (Array.isArray(treeData)) {
    treeData?.forEach(each => {
      each.parent_ids = [..._.get(parent, 'parent_ids', []), parent?.id].filter(id => !!id && id !== ROOT_NODE_ID)
      if (each.children && each.children.length) {
        FlattenTree(each.children, collection, each)
      }
      collection.push(each)
    })
  }
  else if (treeData) {
    FlattenTree([treeData], collection)
  }
}

export default FlattenTree
